export enum ImageAlignEnum {
  ALIGN_LEFT = 'ALIGN_LEFT',
  ALIGN_CENTER = 'ALIGN_CENTER',
  ALIGN_RIGHT = 'ALIGN_RIGHT',
}
